import { PageInfo } from '../types';
import { Page as Log1 } from './log1';
import { Page as Log2 } from './log2';

export const Loglist: PageInfo[] = [
  Log1,
  Log2,
];
